import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import BrandingSection from 'components/settings/projectConfiguration/BrandingSection';

export default function BrandingSectionWrapper({ contextProps, wrappedProps }) {
  return (
    <AppWrapper {...contextProps}>
      <BrandingSection {...wrappedProps} />
    </AppWrapper>
  );
}
